// import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import {
  ContratosCorreccionPara,
  ModulosEnumChoice,
  ROUTER_PATHS,

} from '@/shared';
import {

  useFetchMotivosRechazo,
  useFetchObservacion,
  useUpdateContrato,

} from '@/shared/actions/erp';

import {
  CustomTextArea,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import {
  AlertSeverityEnum,
  Contrato,
  EstadosActualizacionContratoEnum,
  Observacion,
  Responsablev2,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { AcutocompletePromocion } from '@/erp/sytem-sttings/promociones/shared/components';
import { UseFetchResponsablev2 } from '@/shared/actions/erp/responsablev2.actions';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  idIncomingData: string;
  incomingData: Contrato;
  returnURLParam?: string;
}

type RechazoFormData = {
  motivo_rechazo_data?: string;
  motivo_rechazo_data_raw?: any;
  observaciones?: any;
  estado_actualizacion?:string;
  observacion_update_cliente_ventas: string;
  observacion_update_cliente_tecnico: string;
  motivos_rechazo_selected?:string[];
  ultimos_motivos_correccion?:string;
  nombre?:string;
};



export const SendByMotivoRechazoFromOT = {
  toPyl:"ENVIAR A RECOORDINAR",
  toVentas:"ENVIAR A GESTIÓN ASESOR"
}

const RejectClienteDataModal: React.FC<ConfirmRejectOTDialogProps> = ({
  incomingData,
  open,
  idIncomingData,
  setOpen,
  returnURLParam = ROUTER_PATHS.clientes.fibraOpticaNav
}) => {
  const navigate = useNavigate();
  const returnUrlClientes = returnURLParam;

  ///* global state
  const setAlert = useUiStore(s => s.setAlert);

  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);

  ///* form -------------------
  const formRechazo = useForm<RechazoFormData>({
    // resolver: yupResolver(rejectContratoSchema) as any,
    defaultValues: {
      estado_actualizacion: EstadosActualizacionContratoEnum.SOLICITUD_CORRECCION,
    },
  });
  const {
    formState: { errors },
  } = formRechazo;

 
  ///* fetch data
  const { isLoading: isLoadingMotivosCorreccionContrato } =
    useFetchMotivosRechazo({
      estado: true,
      modulo: ModulosEnumChoice.CONTRATOS,
      page_size: 256,
    });
  const {data:datos, isLoading} = useFetchObservacion()


  const {data: datoresponsable} = UseFetchResponsablev2();

  ///* mutations
  const rejectToUpdateContrato = useUpdateContrato({
    navigate,
    returnUrl: returnUrlClientes,
    customSuccessMessage: 'Datos de contrato enviados a corrección',
    enableRedirect: true,
  });

  const onSaveRejection = async (data: RechazoFormData) => {
    
    if(data.motivos_rechazo_selected?.length==0){
      setAlert(
        true,
        'Debe escoger al menos un motivo de corrección',
        AlertSeverityEnum.error
      );
      return
    }
    if(motivoSeleccionado?.includes('VENTAS')&&(!data.observacion_update_cliente_ventas || data.observacion_update_cliente_ventas.trim().length ===0)){
     setAlert(
        true,
        'Debe escoger al menos un motivo de VENTAS',
        AlertSeverityEnum.error
      );
      return
    }
    if(motivoSeleccionado?.includes('TECNICO')&&(!data.observacion_update_cliente_tecnico || data.observacion_update_cliente_tecnico.trim().length ===0)){
     setAlert(
        true,
        'Debe escoger al menos un motivo de TECNICO',
        AlertSeverityEnum.error
      );
      return
    }


      let filtradoVENTAS = data.observacion_update_cliente_ventas?.split(",").map(item => `${item.trim()} - VENTAS`)|| [];
  
   
      let filtradoTecnico =  data.observacion_update_cliente_tecnico?.split(",").map(item => `${item.trim()} - TECNICO`)||[];
    
      let unionTecnicoVentas = [...filtradoTecnico, ...filtradoVENTAS]

    let correccionesTecnico = filtradoTecnico
    let correccionesVentas = filtradoVENTAS
    const auxCorreccionPara = correccionesTecnico?.length!>0 && correccionesVentas?.length!>0?
      ContratosCorreccionPara.VENTAS_TECNICO
    :correccionesTecnico?.length!>0?
      ContratosCorreccionPara.TECNICO
    :correccionesVentas?.length!>0?
      ContratosCorreccionPara.VENTAS
    : null;

    if(!isLoadingMotivosCorreccionContrato){
      
      setOpen(false);
      setIsGlobalLoading(true);

      const auxObservaciones:Record<string, any> = incomingData.observaciones_contrato?.contenido? 
        [...incomingData.observaciones_contrato?.contenido]
        :[];

 

      auxObservaciones.push({
        "motivos": unionTecnicoVentas,
        "observaciones": `${data.observaciones}`,
        "observaciones_ventas": data.observacion_update_cliente_ventas || '',
        "observaciones_tecnico": data.observacion_update_cliente_tecnico || '',
        "fecha": new Date(),
        "migrado": true
      });

  
      
    await rejectToUpdateContrato.mutateAsync({
        id: idIncomingData,
        data: {
          estado_actualizacion: EstadosActualizacionContratoEnum.SOLICITUD_CORRECCION,
          observaciones_contrato:{
            ...incomingData.observaciones_contrato,
            "contenido":auxObservaciones,
            "ultimos_motivos_correccion": data.motivos_rechazo_selected?.toString()!,
          },
          correccion_para: auxCorreccionPara
        },
      });
      setIsGlobalLoading(false);
    }
    
  };
  //validar cual esta dando click
  const motivoSeleccionado = formRechazo.watch("motivos_rechazo_selected");
  const habilitarVentas = Array.isArray(motivoSeleccionado)&&motivoSeleccionado.includes("VENTAS");
  const habilitarTecnicos = Array.isArray(motivoSeleccionado)&&motivoSeleccionado.includes("TECNICO");

  const seleccionadoTecnico =formRechazo.watch("observacion_update_cliente_tecnico");
  const habilitarPorTecnico = !!seleccionadoTecnico && seleccionadoTecnico.length>0;

  
  const seleccionadoVentas = formRechazo.watch("observacion_update_cliente_ventas");
  const habilitarPorVentas = !!seleccionadoVentas && seleccionadoVentas.length>0;

  return (
    <ScrollableDialogProps
      open={open}
      title="Enviar a Actualizar Información de Cliente"
      cancelTextBtn="Cancelar"
      confirmTextBtn="Aprobar"
      confirmVariantBtn="outlined"
      // actions
      onClose={() => {
        setOpen(false);

      }}
      onConfirm={() => {

        formRechazo.handleSubmit(onSaveRejection, (error) => {
          console.log({error})
          setAlert(
            true,
            'Todos los campos son requeridos para enviar a corregir los datos del cliente',
            AlertSeverityEnum.error
          );
        })();
        
      }}
      // content
      minWidth="42%"
      contentNode={
        <>
          <Grid container spacing={3}>
            {/* -------- text -------- */}
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Para enviar a actualizar la información del cliente deberá ingresar el motivo de
                Estado Informe y las observaciones correspondientes <br />
                ¿Está seguro de que desea enviar a corregir la información del cliente?
              </Typography>
            </Grid>

            {/* -------- motivo rechazo -------- */}
            <Grid item xs={12}>
              <AcutocompletePromocion<Responsablev2>
                label="Motivos de Corrección"
                name="motivos_rechazo_selected"
                //// options
                options={
                  (datoresponsable?.data?.data?.filter(x=>x?.tipo_responsable) as any) 
                  || []
                }
                // label & search by name
                valueKey="tipo_responsable"
               
                defaultValue={
                  datoresponsable?.data.data.filter((item: Responsablev2) =>
                    formRechazo.getValues().nombre?.includes(item.tipo_responsable!))
                 
                }
                isLoadingData={isLoadingMotivosCorreccionContrato}
                //// validation
                control={formRechazo.control}
                error={!!errors.motivos_rechazo_selected}
                helperText={formRechazo.formState.errors.motivos_rechazo_selected?.message}

                textFieldKey="nombre_observacion"
                actualValueKey="tipo_responsable"
                onChangeRawValue={v => {
                  formRechazo.setValue(
                    'motivos_rechazo_selected',
                    v?.map((item) => item?.tipo_responsable!)
                  );

     
                }}
              />
            </Grid> 
            <Grid item xs={12}>

              
    
              <AcutocompletePromocion<Observacion>
                  label="Observación Ventas"
                  name="observacion_update_cliente_ventas"
                  
                  options={
                  (datos?.data?.data?.filter(x=>x?.responsable_data?.tipo_responsable.includes("VENTAS")) as any) 
                  || []}
                  valueKey ="nombre_observacion"                  
                  textFieldKey="nombre_observacion"
                  actualValueKey="nombre_observacion"

                  isLoadingData={isLoading}
                  control={formRechazo.control}
                  error={!!errors.observacion_update_cliente_ventas}
                  helperText={formRechazo.formState.errors.observacion_update_cliente_ventas?.message}
              
                  disabled ={
                    !habilitarVentas
                  }
                  onChangeRawValue={v => {
                    formRechazo.setValue('observacion_update_cliente_ventas',
                      v?.map((item) => item?.nombre_observacion!).filter(Boolean).join(", ")?? "",
                    );
                }}
              />
            
            </Grid>

           
            {/* </Grid> */}
            <Grid item xs={12}>
              
              <AcutocompletePromocion<Observacion>
                  label="Observación Técnico"
                  name="observacion_update_cliente_tecnico"
                  
                  options={
                  (datos?.data?.data?.filter(x=>x?.responsable_data?.tipo_responsable.includes("TECNICO")) as any) 
                  || []}

                  valueKey ="nombre_observacion"
                  textFieldKey="nombre_observacion"
                  actualValueKey="nombre_observacion"
                  disabled ={
                    !habilitarTecnicos
                  }

                  isLoadingData={isLoadingMotivosCorreccionContrato}
                  control={formRechazo.control}
                  error={!!errors.motivos_rechazo_selected}
                  helperText={formRechazo.formState.errors.motivos_rechazo_selected?.message}
                  onChangeRawValue={v => {
                    formRechazo.setValue('observacion_update_cliente_tecnico',
                      v?.map((item) => item?.nombre_observacion!).filter(Boolean).join(", ")?? "",
                    );
                }}
              />
              
            </Grid>
            <Grid item xs={12}>
                  <CustomTextArea
                    label="Observación"
                    name="observaciones"
                    control={formRechazo.control}
                    defaultValue={
                      formRechazo.getValues('observaciones') || ''
                    }
                   disabled={
                     !habilitarPorTecnico&& !habilitarPorVentas
                   }
                    error={formRechazo.formState.errors.observacion_update_cliente_ventas}
                    helperText={
                      formRechazo.formState.errors.observacion_update_cliente_tecnico
                        ?.message
                    }
                    required={false}
              />
              </Grid>
          </Grid>
        </>
      }
    />
  );
};

export default RejectClienteDataModal;
